import { FuseNavigationModelInterface } from '../core/components/navigation/navigation.model';

export class FuseInstructorNavigationModel implements FuseNavigationModelInterface
{
    public model: any[];

    constructor()
    {
        this.model = [
            {
                'id'      : 'admin',
                'title'   : 'SuperAdmin',
                'translate': 'NAV.ADMIN',
                'type'    : 'group',
                'children': [
                    {
                        'id'   : 'users',
                        'title': 'Users',
                        'translate': 'NAV.USERS.TITLE',
                        'type' : 'item',
                        'icon' : 'person',
                        'url'  : '/users',
                    }
                    ,
                    {
                        'id'   : 'progress',
                        'title': 'User progress',
                        'translate': 'NAV.PROGRESS.TITLE',
                        'type' : 'item',
                        'icon' : 'timeline',
                        'url'  : '/progress',
                    }
                ]
            }
        ];
    }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/navigation/instructor.navigation.model.ts